import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';
import {createApplicationState} from '@services/ApplicationState';
import {IApplicationState} from '@services/types';

export class CategoryCollapse extends ConnectedComponent {
  private appState: IApplicationState = createApplicationState();

  constructor() {
    super();
    this.onPress = this.onPress.bind(this);
  }

  didMount() {
    this.observe(appSelectors.selectNewsUrl, async () => {
      this.element?.querySelector('.a-tag')?.classList.remove('active');
    });

    this.on('click', this.onPress);
  }

  async onPress(e: MouseEvent) {
    const target = e.currentTarget as HTMLAnchorElement;
    const link = target.dataset['link'];

    e.preventDefault();

    if (link) {
      this.appState.updateNewsUrl(link);
      target && target.querySelector('.a-tag')?.classList.add('active');
    }
    return false;
  }
}
